import * as i1 from '@abp/ng.core';
import { mapEnumToOptions } from '@abp/ng.core';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

class LeptonThemeSettingsService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'LeptonThemeManagement';
        this.get = () => this.restService.request({
            method: 'GET',
            url: '/api/lepton-theme-management/settings',
        }, { apiName: this.apiName });
        this.update = (input) => this.restService.request({
            method: 'PUT',
            url: '/api/lepton-theme-management/settings',
            body: input,
        }, { apiName: this.apiName });
    }
}
LeptonThemeSettingsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: LeptonThemeSettingsService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable });
LeptonThemeSettingsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: LeptonThemeSettingsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.2", ngImport: i0, type: LeptonThemeSettingsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.RestService }]; } });

var LeptonStyle;
(function (LeptonStyle) {
    LeptonStyle[LeptonStyle["Style1"] = 0] = "Style1";
    LeptonStyle[LeptonStyle["Style2"] = 1] = "Style2";
    LeptonStyle[LeptonStyle["Style3"] = 2] = "Style3";
    LeptonStyle[LeptonStyle["Style4"] = 3] = "Style4";
    LeptonStyle[LeptonStyle["Style5"] = 4] = "Style5";
    LeptonStyle[LeptonStyle["Style6"] = 5] = "Style6";
})(LeptonStyle || (LeptonStyle = {}));
const leptonStyleOptions = mapEnumToOptions(LeptonStyle);

var MenuPlacement;
(function (MenuPlacement) {
    MenuPlacement[MenuPlacement["Left"] = 0] = "Left";
    MenuPlacement[MenuPlacement["Top"] = 1] = "Top";
})(MenuPlacement || (MenuPlacement = {}));
const menuPlacementOptions = mapEnumToOptions(MenuPlacement);

var MenuStatus;
(function (MenuStatus) {
    MenuStatus[MenuStatus["AlwaysOpened"] = 0] = "AlwaysOpened";
    MenuStatus[MenuStatus["OpenOnHover"] = 1] = "OpenOnHover";
})(MenuStatus || (MenuStatus = {}));
const menuStatusOptions = mapEnumToOptions(MenuStatus);

/**
 * Generated bundle index. Do not edit.
 */

export { LeptonStyle, LeptonThemeSettingsService, MenuPlacement, MenuStatus, leptonStyleOptions, menuPlacementOptions, menuStatusOptions };
